import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"; 
import { getFirestore, doc, setDoc, getDoc,query,where, getDocs , updateDoc, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
 
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import Cookies from 'js-cookie';
import { useToast } from '../components/ToastContext';    
import Header from '../master_root/header';
//page links  
export default function LocaleServices() {
  return (
           <div >
       <Header /> 
     <div className='app_header_height'></div>
    <div className="container_roots">
    <Helmet>
        <title>EditorTask - Local Services Near You</title>

        <meta name="description" content="Discover and offer lifestyle and local services like event planning, interior design, personal coaching, and more on EditorTask. Connect with skilled professionals in your area." />
        <meta name="keywords" content="local services, lifestyle tasks, event planners, interior design, fitness coaching, resume writing, personal coaching, EditorTask" />
        <meta name="author" content="editortask.com" />
        <meta name="robots" content="index, follow" />

        <meta property="og:title" content="EditorTask - Local Services Near You" />
        <meta property="og:description" content="Hire or offer services like coaching, fitness, interior design, and more. Find skilled local professionals on EditorTask." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.editortask.com/locale-services" />
        <meta property="og:image" content="https://www.editortask.com/editortask_logo.png" />
      </Helmet>
      <div className="container_size">
        <h2 className="contact-title">Local Services</h2>
        <p>Discover local experts offering services to make life easier, more creative, and better managed. Whether you're hiring or providing services, EditorTask helps connect professionals with people who need them.</p>
        
        <ul className="service-list">
          <li><b>Event Planning</b> – Organize private or public events with the help of local experts.</li>
          <li><b>Interior Design</b> – Find professional designers to transform your space beautifully.</li>
          <li><b>Personal Coaching</b> – Life, career, or business coaching tailored to your needs.</li>
          <li><b>Health & Fitness</b> – Trainers, yoga coaches, or diet experts near you.</li>
          <li><b>Resume & Cover Letter Writing</b> – Get hired with professionally crafted resumes.</li>
        </ul>
      </div>
      </div>
</div>
    );
}
